import DataRecordStatusTemplate from '../../components/5templates/DataRecordStatusTemplate'
import { useEffect, useState } from 'react'
import ApiService from '../../common/ApiCalls'
import { sortAlphabetically } from '../../services/util/miscellaneousService'

const DataRecordStatusTab = () => {
  const userId = localStorage.getItem('userId')
  const [dataRecordListFull, setDataRecordListFull] = useState([])
  const [dataRecordListMyApproval, setDataRecordListMyApproval] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPosts, setTotalPosts] = useState(0)

  const [showAllApproval, setShowAllApproval] = useState(false)
  const onSwitchChange = () => {
    setShowAllApproval(!showAllApproval)
  }

  const dataList = showAllApproval ? dataRecordListFull : dataRecordListMyApproval

  const generateDataRecordListFull = (res) => {
    const dataRecordListFull = []

    for (let i = 0; i < res.length; i++) {
      const { approver_id, pending_data_id, import_type, status, created_at, approver_name, initiator_name } = res[i]
      dataRecordListFull.push({
        approverId: approver_id,
        id: pending_data_id,
        name: import_type,
        status,
        created_at,
        approver_name,
        initiator_name
      })
    }
    sortAlphabetically(dataRecordListFull, 'created_at')
    dataRecordListFull.reverse() // The latest record will be on the top
    sortAlphabetically(dataRecordListFull, 'status')

    return dataRecordListFull
  }

  const generateDataRecordListMyApproval = (res) => {
    const dataRecordListMyApproval = []
    for (let i = 0; i < res.length; i++) {
      const { pending_data_id, import_type, status, approver_id, initiator_id, created_at, approver_name, initiator_name } = res[i]
      if (userId === approver_id || userId === initiator_id) {
        dataRecordListMyApproval.push({
          approverId: approver_id,
          id: pending_data_id,
          name: import_type,
          status,
          created_at,
          approver_name,
          initiator_name
        })
      }
    }
    sortAlphabetically(dataRecordListMyApproval, 'created_at')
    dataRecordListMyApproval.reverse() // The latest record will be on the top
    sortAlphabetically(dataRecordListMyApproval, 'status')
    return dataRecordListMyApproval
  }

  useEffect(() => {
    const getDataRecordListFull = async () => {
      const res = await ApiService().getAllPendingDashboardData()
      const res2 = await ApiService().getAllPendingDataImports()

      const allRes = res.concat(res2)

      allRes.forEach(oneItem => oneItem.created_at = new Date(oneItem.created_at).toString())

      const fullList = generateDataRecordListFull(allRes)
      const myApproval = generateDataRecordListMyApproval(allRes)

      setTotalPosts(fullList.length)
      setDataRecordListMyApproval(myApproval)
      setDataRecordListFull(fullList)
    }
    getDataRecordListFull()
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [])

  return (
    <>
      <DataRecordStatusTemplate
        recordStatusData={dataList} currentPage={currentPage}
        totalPosts={totalPosts} setCurrentPage={setCurrentPage}
        checked={showAllApproval} onChange={onSwitchChange}
      />
    </>
  )
}

export default DataRecordStatusTab
